import React, { Component } from 'react';
import Select from 'react-select';
import { Button, TextInput } from 'carbon-components-react';
import appConfig from '../../../config/app-config';
import { StepCard } from '../../index';
import { getDmService, getByDmService } from '../../../services/Api';

class SelectedProducts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      nextComponent: false,
      aplication: { id: null, label: null },
      variable: { id: null, label: null },
      listProducts: [],
      listMaterials: [],
      listDetails: [],
      listAplication: [],
      listVariables: [],
      listImageProducts: [],
      detailSearched: false,
      messageNotFound: false,
      imgSelected: { id: null, path: null },
      product: {},
      advanced: false,
      found: false,
      requiredComplement: "",
      idUrl: null,
      subIdUrl: null,
      isFinished: false,
      disabledVariables: true,
      exigeComplemento: false,
      material: { id: null, label: null },
      dataRequiredComplement: null,
      hasChanged: false,
      hasSubId: false,
      createText: null,
    }
  }

  componentWillMount = async () => {
    const { urlId, dataRequest } = this.props;
    await this.loadProduct(urlId);
    // console.log("in will mount", dataRequest);
    await this.setState({
      dataRequiredComplement: dataRequest.outraAplicacao
    })
  }

  componentWillUpdate = async () => {
    const { match } = this.props;
    const { idUrl, subIdUrl } = this.state;
    const urlNow = idUrl;
    const subIdNow = subIdUrl;
    if (urlNow !== match.params.id || subIdNow !== match.params.subId) {

      await this.setState({
        idUrl: match.params.id,
        subIdUrl: match.params.subId,
        aplication: { id: null, label: null },
        variable: { id: null, label: null },
        listImageProducts: [],
        messageNotFound: false,
        found: false,
        isFinished: false,
        dataFilter: [],
        listVariables: [],
        disabledVariables: true,
        material: { id: null, label: null },
        detail: { id: null, label: null },
        imgSelected: false,

      });

      await this.loadProduct(match.params.id);
      await this.verifyFound();
    }
  }

  verifyFound = async () => {
    const { product } = this.state;
    if (product && product.id) {
      await this.onChangeProduct(product)
    }
  }

  verifyFoundRequest = (data, type) => {
    const { dataRequest, dataProduct } = this.props;
    const {
      idProduto,
      idMaterial,
      idDetalhe,
      localAplicacao,
      variaveisAplicacao,
      idStatusPedido,
    } = dataRequest
    let idsSearch = []
    let selected = { id: null, label: null }

    if (type === "product") {
      if (idProduto > 0) {
        const result = idStatusPedido !== 25 ? parseInt(idProduto, 10) : parseInt(dataProduct.dataFilters.idProduto, 10)
        idsSearch = data.find(item => parseInt(item.id, 10) === result);
      }
    } else if (type === "material") {
      if (idMaterial > 0) {
        const result = idStatusPedido !== 25 ? parseInt(idMaterial, 10) : parseInt(dataProduct.dataFilters.idMaterial, 10);
        idsSearch = data.find(item => parseInt(item.id, 10) === result);
      }
      this.loadDetail()
    } else if (type === "detail") {
      if (idDetalhe > 0) {
        const result = idStatusPedido !== 25 ? parseInt(idDetalhe, 10) : parseInt(dataProduct.dataFilters.idDetalhe, 10);
        idsSearch = data.find(item => parseInt(item.id, 10) === result);
      }

    } else if (type === "application") {
      if (localAplicacao > 0) {
        idsSearch = data.listaAplicacoes.find(item => parseInt(item.id, 10) === parseInt(localAplicacao, 10))
      }

    } else if (type === "variable") {
      if (data.length) {
        if (variaveisAplicacao > 0) {
          idsSearch = data.find(item => parseInt(item.id, 10) === parseInt(variaveisAplicacao, 10))
        }
      } else {
        idsSearch = [];
      }

    } else {
      return false
    }

    if (type === "detail") {
      selected = Object.prototype.hasOwnProperty.call(idsSearch, "descricao") ? { id: idsSearch.id, label: idsSearch.descricao } : { id: null, label: null }
      this.onChangeDetail(selected)
    } else if (type === "variable") {
      if (idsSearch !== undefined) {
        selected = Object.prototype.hasOwnProperty.call(idsSearch, "label") ? { id: idsSearch.id, label: idsSearch.value } : { id: null, label: null }
      } else {
        selected = { id: null, label: null, value: null };
      }

    } else {
      selected = Object.prototype.hasOwnProperty.call(idsSearch, "nome") ? { id: idsSearch.id, label: idsSearch.nome, descricao: idsSearch.descricao } : { id: null, label: null }
    }
    // console.log(selected, "selected")
    return selected
  }

  onChangeProduct = event => {
    const { match } = this.props;
    const { product, hasChanged } = this.state;
    this.setState({
      hasChanged: hasChanged || (product.id !== null && event.id !== product.id),
      product: event,
      produtoDescricao: event.descricao,

    }, async () => {
      await this.loadMaterial(match.params.id);
    });
  }

  onChangeMaterial = event => {
    const { material, hasChanged } = this.state;
    this.setState({
      hasChanged: hasChanged || (material.id !== null && material.id !== event.id),
      material: event
    }, async () => {
      await this.loadDetail();
    });
  }

  onChangeDetail = event => {
    const { detail, hasChanged } = this.state;
    this.setState({
      hasChanged: hasChanged || (detail.id !== null && detail.id !== event.id),
      detail: event,
      detailSearched: true,
      listVariables: [],
    }, async () => {
      await this.loadSearchProduct();
    })
  }

  onChangeAplication = event => {
    const { aplication, hasChanged } = this.state;
    this.setState({
      hasChanged: hasChanged || (aplication.id !== null && aplication.id !== event.id),
      aplication: event,
      disabledVariables: true,
      requiredComplement: "",
      variable: { id: null, label: null }
    }, () => {
      this.loadVariable();
    });
  }

  onChangeVariable = event => {
    const { variable, hasChanged } = this.state;
    this.setState({
      hasChanged: hasChanged || (variable.id !== null && variable.id !== event.id),
      variable: event,
      disabledVariables: false
    })
  }

  onChangeComplement = event => {
    const { dataRequiredComplement, hasChanged } = this.state;
    this.setState({
      hasChanged: hasChanged || (dataRequiredComplement && dataRequiredComplement.id !== null && dataRequiredComplement.id !== event.id),
      dataRequiredComplement: event
    })
  }

  loadProduct = async (id) => {
    const { dataRequest, match } = this.props;
    const existRequest = dataRequest && Object.prototype.hasOwnProperty.call(dataRequest, "idGrupo");
    const subId = match.params.subId;
    if (id) {
      let data = await getDmService(`/Pedido/GetNomeProduto/?grupo=${id}&mostraAtivos=true`)

      if (existRequest) {
        const { idGrupo } = dataRequest
        data = await getDmService(`/Pedido/GetNomeProduto/?grupo=${idGrupo}&mostraAtivos=false`);
      }
      let produtoDescricao = "";
      // let tipoUsoProduto = "";
      // console.log("data1", data)
      const list = data.map(item => ({ id: item.id, label: item.nome, descricao: item.descricao }));
      let selectedProduct = { id: null, label: null,  tipoUso: null};
      if (data.length === 1) {
        selectedProduct = { id: data[0].id, label: data[0].nome, descricao: data[0].descricao, tipoUso: data[0].tipoUso }
        produtoDescricao = data[0].descricao
      }
      if (subId) {
        const product = data.find(p => p.id === Number(subId));
        selectedProduct = { id: product.id, label: product.nome, descricao: product.descricao, tipoUso: product.tipoUso};
        produtoDescricao = produtoDescricao.descricao;
      }
      if (existRequest) {
        selectedProduct = this.verifyFoundRequest(data, "product");
        if (selectedProduct) {
          produtoDescricao = (data.find(p => p.id === selectedProduct.id) || {}).descricao
        }
      }

      await this.setState({
        produtoDescricao,
        listProducts: list,
        product: selectedProduct,
        requiredComplement: dataRequest.outraAplicacao,
        hasSubId: match.params.subId ? true : false,
        tipoUso: data.tipoUso
      });
    }
  }

  loadMaterial = async id => {
    const { product } = this.state;
    const { dataRequest } = this.props;
    const existRequest = dataRequest && Object.prototype.hasOwnProperty.call(dataRequest, "idMaterial")
    let data = [];
    if (existRequest) {
      data = await getDmService(`/material/GetByGrupo/?grupo=${dataRequest.idGrupo}&nomeProduto=${dataRequest.idProduto}&mostraAtivos=true`);
    } else {
      data = await getDmService(`/material/GetByGrupo/?grupo=${id}&nomeProduto=${product.id}&mostraAtivos=false`);
    }

    const list = data.map(item => ({ id: item.id, label: item.nome }));

    let selectedMaterial = data.length === 1 ? { id: data[0].id, label: data[0].nome, search: true } : { id: null, label: null, search: false };
    if (existRequest) { selectedMaterial = this.verifyFoundRequest(data, "material"); }

    await this.setState({
      listMaterials: list,
      material: selectedMaterial
    }, () => {
      this.loadDetail();
    });
  }

  loadDetail = async () => {
    const { product, material } = this.state;
    const { dataRequest } = this.props;
    const existRequest = dataRequest && Object.prototype.hasOwnProperty.call(dataRequest, "idMaterial")
    let data = []
    if (existRequest) {
      data = await getDmService(`/Pedido/GetDetalhe/?nomeProduto=${dataRequest.idProduto}&mostraAtivos=false`);
    } else {
      data = await getDmService(`/Pedido/GetDetalhe/?nomeProduto=${product.id}&mostraAtivos=false`);
    }

    let selectedDetail = { id: null, label: null }
    if (material.id) {
      selectedDetail = data && data.length === 1 ? { id: data[0].id, label: data[0].descricao } : { id: null, label: null }
      if (existRequest) { selectedDetail = await this.verifyFoundRequest(data, "detail"); }
      const list = data.map(item => ({ id: item.id, label: item.descricao }))
      await this.setState({
        listDetails: list,
        detail: selectedDetail
      }, async () => {
        await this.loadSearchProduct()
      });
    }
  }

  loadVariable = async () => {
    const { aplication } = this.state;
    const { dataRequest, saveStep } = this.props;
    const existRequest = dataRequest && Object.prototype.hasOwnProperty.call(dataRequest, "idMaterial")
    const data = await getByDmService(`/Aplicacao`, aplication.id);
    const variables = [];
    const { exigeComplemento } = data;

    if (data.fracionado) {
      variables.push({ id: variables.length + 1, label: "Fracionado", value: "fracionado" });
    }
    if (data.sequencial) {
      variables.push({ id: variables.length + 1, label: "Sequêncial", value: "sequencial" });
    }
    if (data.unico) {
      variables.push({ id: variables.length + 1, label: "Único", value: "unico" });
    }

    const disabled = !variables.length;
    const idxArray = 0;
    let selectedVariable = { id: null, label: null };
    if (variables.length === 1) {
      selectedVariable = variables[idxArray];
    }

    if (existRequest) {
      selectedVariable = this.verifyFoundRequest(variables, "variable")
    }

    this.setState({
      listVariables: variables,
      disabledVariables: disabled,
      variable: selectedVariable,
      exigeComplemento,
    });
    if (selectedVariable)
      await saveStep({ variableSave: { id: selectedVariable.id, value: selectedVariable.label } });
  }

  loadSearchProduct = async () => {
    const { product, material, detail, detailSearched, aplication } = this.state;
    const { urlId, dataRequest } = this.props;
    const { idGrupo, idProduto, idMaterial, idDetalhe, idItem } = dataRequest
    const existRequest = dataRequest && Object.prototype.hasOwnProperty.call(dataRequest, "idMaterial")
    const validatRequirements = product && product.id !== 0 && material && material.id !== 0;
    if (validatRequirements) {
      try {
        let data = [];
        if (existRequest) {
          data = await getDmService(`/ProdutoAgencia/Busca/?IdGrupo=${idGrupo}&IdDescricao=${idProduto}&IdMaterial=${idMaterial}&IdDetalhe=${idDetalhe}&IdItem=${idItem}`);
        } else {
          data = await getDmService(`/ProdutoAgencia/Busca/?IdGrupo=${urlId}&IdDescricao=${product.id}&IdMaterial=${material.id}&IdDetalhe=${detail.id}&IdItem=${0}`);
        }

        const list = await data.listaAplicacoes.map(item => ({ id: item.id, label: item.nome }));

        let selectedApplication = list.length === 1 ? list[0] : aplication;
        if (existRequest) {
          selectedApplication = await this.verifyFoundRequest(data, "application")
        }
        const imgsProducts =
          await data.fotos
            ? data.fotos.map(item => ({ id: item.id, path: item.caminho }))
            : [];
        const { exigeComplemento } = data;

        await this.setState({
          dataFilter: data,
          listAplication: list,
          listImageProducts: imgsProducts,
          imgSelected: imgsProducts.length ? imgsProducts[0].path : false,
          aplication: selectedApplication,
          messageNotFound: false,
          found: true,
          exigeComplemento
        }, () => {
          this.onChangeAplication(selectedApplication);
          // saveStep()
        })
      } catch (error) {
        if (detailSearched) {
          this.setState({
            found: false,
            messageNotFound: true
          })
        }
      }
    }
  }

  setImagem = selected => {
    this.setState({
      imgSelected: selected
    })
  }

  advance = async () => {
    const { saveStep } = this.props;
    const {
      product,
      material,
      detail,
      aplication,
      variable,
      dataRequiredComplement,
      dataFilter,
      found,
      hasChanged
    } = this.state;

    await saveStep({
      dataFilters: dataFilter,
      productSave: product,
      materialSave: material,
      detailSave: detail,
      aplicationSave: aplication,
      variableSave: variable,
      requiredComplementSave: dataRequiredComplement,
      found,
      hasChanged
    }, 'SelectedProduct');
    await this.setState({ nextComponent: true, isFinished: true, hasChanged: false })
    this.stepCardRef.toggleContent();
  }

  cancel = () => {
    this.stepCardRef.toggleContent();
  }

  renderDescription = () => {
    const {
      product,
      material,
      detail,
      aplication,
      variable,
      requiredComplement,
      nextComponent,
      dataFilter
    } = this.state;
    const { dataRequest } = this.props
    const existRequest = Object.prototype.hasOwnProperty.call(dataRequest, "idGrupo");
    const dataRequiredComplement = dataRequest.outraAplicacao || requiredComplement;
    return (
      <div>
        {(nextComponent || existRequest) && (
          <div>
            {dataFilter && dataFilter.codigo &&
              (
                <p>
                  <strong>Código:</strong>
                  {' '}
                  {dataFilter.codigo}
                </p>
              )}
            {product.id !== 0 &&
              (
                <p>
                  <strong>Produto:</strong>
                  {' '}
                  {product.label}
                </p>
              )}
            {material.id !== 0 && (
              <p>
                <strong>Material:</strong>
                {' '}
                {material.label}
              </p>
            )}
            {detail && detail.id !== 0 && (
              <p>
                <strong>Detalhe:</strong>
                {' '}
                {detail.label}
              </p>
            )}
            {aplication.id !== 0 && (
              <p>
                <strong>Aplicação:</strong>
                {` ${aplication.label}  ${dataRequiredComplement !== "" ? ` : ${dataRequiredComplement}` : ""}`}
              </p>
            )}
            {variable && variable.label !== null && (
              <p>
                <strong>Variável de aplicação:</strong>
                {' '}
                {variable.label}
              </p>
            )}
          </div>
        )}
      </div>
    )
  }

  render() {
    const {
      product,
      material,
      detail,
      aplication,
      variable,
      listMaterials,
      listProducts,
      listDetails,
      listAplication,
      listVariables,
      advanced,
      found,
      messageNotFound,
      listImageProducts,
      imgSelected,
      requiredComplement,
      dataRequiredComplement,
      disabledVariables,
      exigeComplemento,
      isFinished,
      produtoDescricao,
      hasSubId
    } = this.state;

    const { dataRequest, disabled } = this.props;
    const existRequest = Object.prototype.hasOwnProperty.call(dataRequest, "idGrupo");

    const { IMAGE_PATH } = appConfig;
    const requiredYes = true;
    const mandatoryAddon = variable.label === "Exige Complemento" && (requiredComplement.length < 5) ? requiredYes : !requiredYes;
    const haveMaterial = material.search
    const validateVariable = (disabledVariables && variable.id === null) || (!disabledVariables && variable.id !== null);
    const requiredVariables = aplication.id !== null ? validateVariable : requiredYes;
    const disabledAdvanced = mandatoryAddon || !requiredVariables;

    return (
      <div>
        <StepCard
          onRef={ref => {
            this.stepCardRef = ref;
          }}
          title="Seleção do produto"
          description={(isFinished || existRequest) && this.renderDescription()}
          isFinished={(isFinished && found) || existRequest}
          onToogle={advanced}
          disabled={disabled === true}
        >
          <div className="bx--row">
            <div className="bx--col-xs-12 bx--col-md-6">
              <div className="bx--row">
                <div className="bx--col-xs-12 v-md-margin">
                  <label className="bx--label">Produto</label>
                  <Select
                    className="search-dm"
                    name="product"
                    options={listProducts}
                    value={product}
                    onChange={this.onChangeProduct}
                    placeholder="Digite o código ou selecione"
                    isClearable={false}
                    disabled={listProducts.length <= 1 || existRequest || hasSubId}
                    isSearchable
                  />
                </div>
                <div className="bx--col-xs-12 v-md-margin">
                  <label className="bx--label">Material</label>
                  <Select
                    className="search-dm"
                    name="material"
                    options={listMaterials}
                    value={material}
                    onChange={this.onChangeMaterial}
                    placeholder="Digite o código ou selecione"
                    isClearable={false}
                    disabled={listMaterials.length <= 1}
                    isSearchable
                  />
                </div>
                <div className="bx--col-xs-12 v-md-margin">
                  <label className="bx--label">Detalhe</label>
                  <Select
                    className="search-dm"
                    name="material"
                    options={listDetails}
                    value={detail}
                    onChange={this.onChangeDetail}
                    placeholder="Digite o código ou selecione"
                    isClearable={false}
                    disabled={listDetails.length <= 1}
                    isSearchable
                  />
                </div>
                <div className="bx--col-xs-12 v-md-margin">
                  <label className="bx--label">Aplicação</label>
                  <Select
                    className="search-dm"
                    name="material"
                    options={listAplication}
                    value={aplication}
                    onChange={this.onChangeAplication}
                    placeholder="Digite o código ou selecione"
                    isClearable={false}
                    disabled={listAplication.length <= 1}
                    isSearchable
                  />
                </div>
                {exigeComplemento && (
                  <div className="bx--col-xs-12 v-md-margin">
                    <TextInput
                      labelText=""
                      value={dataRequiredComplement || ""}
                      onChange={e => this.onChangeComplement(e.target.value)}
                      placeholder="Digite onde será aplicado"
                    />
                  </div>
                )}
                <div className="bx--col-xs-12 v-md-margin">
                  <label className="bx--label">Variáveis de aplicação</label>
                  <Select
                    className="search-dm"
                    name="material"
                    options={listVariables}
                    value={variable}
                    onChange={this.onChangeVariable}
                    placeholder="Digite o código ou selecione"
                    isClearable={false}
                    disabled={disabledVariables || listVariables.length <= 1}
                    isSearchable
                  />
                </div>
              </div>
            </div>
            <div className="bx--col-xs-12 bx--col-md-6">
              <p style={{ marginTop: 15, marginBottom: 20, textAlign: "center" }}><strong>{produtoDescricao}</strong></p>
              {messageNotFound && (
                <div className="message-search-not-found">
                  <img
                    className="img-responsive animated tada delay-5s"
                    alt="thumbnail"
                    src={require(`../../../assets/images/search-not-found.png`)}
                  />
                  <p>
                    <span>
                      Por favor verifique,
                    </span>
                    {' '}
                    pois não foram encontrados produtos para os filtros selecionados.
                  </p>
                </div>
              )}
              {(!messageNotFound && !imgSelected && haveMaterial) && (
                <div className="message-search-success">
                  <i className="material-icons animated tada delay-5s">done_all</i>
                  <p>
                    O produto que você está procurando foi encontrado
                  </p>
                </div>
              )}
              {(found && !messageNotFound && imgSelected) && (
                <React.Fragment>
                  <div className="bx--row">
                    <div className="bx--col-md-12 mg-top-20">
                      <div>
                        <img
                          className="img-responsive img-force animated fadeInDownBig delay-5s "
                          alt="Imagem do produto"
                          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII="
                          style={{ backgroundImage: `url('${IMAGE_PATH}${imgSelected}')` }}
                        />
                      </div>
                    </div>
                    {listImageProducts.map(img => (
                      <div key={img.id} className="bx--col-md-4 bx--col-xs-6 mg-top-20 pointer">
                        <img
                          onClick={() => this.setImagem(img.path)}
                          className="img-responsive img-galery"
                          alt="thumbnail"
                          src={`${IMAGE_PATH}${img.path}`}
                        />
                      </div>
                    ))
                    }
                  </div>
                </React.Fragment>
              )}
            </div>
          </div>
          <div className="bx--row">
            <div className="bx--col-xs-12 bx--col-md-12 v-md-margin">
              <Button
                onClick={this.advance}
                className="bx--btn btn-secondary-color"
                disabled={disabledAdvanced}>
                Avançar
              </Button>
              <Button
                kind="ghost"
                className="bx--btn btn-secondary-outlined h-sm-margin"
                onClick={this.cancel}
              >
                Cancelar
              </Button>
            </div>
          </div>
        </StepCard>
      </div>
    )
  }
}

export default SelectedProducts;



// WEBPACK FOOTER //
// ./src/components/agency/requests/SelectedProducts.js